











import { Component, Vue } from 'vue-property-decorator';
import GlobalEvents from '@/logic/GlobalEvents';
import PullTo from 'vue-pull-to';

@Component({
    components: {
        PullTo
    }
})
export default class PullRefresh extends Vue {

    private isAtTop = true;

    private CONFIG = {
        pullText: 'Pull', // The text is displayed when you pull down
        triggerText: 'Refresh', // The text that appears when the trigger distance is pulled down
        loadingText: 'Refreshing...', // The text in the load
        doneText: 'Done', // Load the finished text
        failText: 'Failed', // Load failed text
        loadedStayTime: 400, // Time to stay after loading ms
        stayDistance: 30, // Trigger the distance after the refresh
        triggerDistance: 40 // Pull down the trigger to trigger the distance
    };

    private mounted() {

        // Track if we are scrolled to the top
        window.onscroll = (e) => {
            this.isAtTop = (e.target.scrollingElement.scrollTop === 0);
        };
    }

    private refresh(loaded) {
        GlobalEvents.$emit('local-refresh');
        GlobalEvents.$on('local-refresh-done', () => {
            loaded('done');
            GlobalEvents.$off('local-refresh-done');
        });
    }
}
